import { useState, useEffect } from 'react';
import { useUser } from '../components/UserContext';
import { pobierzPrzedmiot } from '../data/pytania';

/** Ile pytań z przedmiotu widzi użytkownik bez wykupionego dostępu. */
export const LIMIT_DEMO = 10;

/**
 * Pytania jednego przedmiotu do trybu nauki.
 *
 * Treść bierzemy z lokalnych plików generowanych przez scripts/pytania/gen.py,
 * a nie z API. Powód jest ten sam co przy stronach /pytania/<slug>: prerender
 * zrzuca DOM po budżecie czasu wirtualnego, który nie czeka na odpowiedź
 * z zewnętrznego hosta (API i tak odrzuca origin http://localhost). Przy
 * pobieraniu z API strony nauki zapisywały się puste, a to one mają łapać ruch
 * z wyszukiwarki. Plik przedmiotu dociąga się osobną paczką, więc odwiedzający
 * pobiera tylko swój fragment bazy.
 *
 * Dostęp płatny zmienia tu wielkość porcji, a nie samo źródło: bez dostępu
 * pokazujemy pierwsze LIMIT_DEMO pytań, z dostępem cały przedmiot.
 */
export const useNauka = ({ licencja, przedmiot }) => {
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useUser();

  const isTestAccessValid = user && user.test_access_till
    ? new Date() < new Date(user.test_access_till)
    : false;

  useEffect(() => {
    if (!licencja || !przedmiot) return undefined;

    let anulowane = false;
    setLoading(true);
    setError(null);

    pobierzPrzedmiot(przedmiot)
      .then(wszystkie => {
        if (anulowane) return;
        // Część pytań obowiązuje tylko na wybranych uprawnieniach - filtrujemy,
        // żeby ucząc się do drona nie dostać pytania wyłącznie samolotowego.
        const dopasowane = wszystkie.filter(
          q => !q.licencje || !q.licencje.length || q.licencje.includes(licencja)
        );
        setQuestions(isTestAccessValid ? dopasowane : dopasowane.slice(0, LIMIT_DEMO));
      })
      .catch(err => !anulowane && setError(err.message))
      .finally(() => !anulowane && setLoading(false));

    return () => {
      anulowane = true;
    };
  }, [licencja, przedmiot, isTestAccessValid]);

  return { questions, error, loading, demo: !isTestAccessValid };
};
